/**
 * 车辆二维码模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// getToken
Mock.mock(/^\/api\/v1\/csfr_token$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'plate_number': '粤b12345'
  }
})
// 车辆二维码
Mock.mock(/^\/api\/v1\/take_over_serve_car\/\d+$/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'plate_number': '粤b12345'
  }
})
